import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Loader from '../loader/Loader';
import DarkLogo from '../../app/common/DarkLogo';
import { useEffect, useState } from 'react';
import axios from 'axios';
import {
  setUserSessionEmail,
  setUserData,
} from '../../app/services/AuthService';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getApiKey, getUrl } from '../../app/api/agent';
import { Alert } from '@mui/material';
import { renderToString } from 'react-dom/server';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { useBookingEvent } from '../../hooks/useBookingEvent';
// import { initializePixel } from '../../utils/facebookPixel';

export default function CreateSingle() {
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [password, setPassword] = useState('');
  const [missingParameters, setMissingParameters] = useState(false);
  const [authenticating, setAuthenticating] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const navigate = useNavigate();
  // eslint-disable-next-line
  const [searchParams, setSearchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const { handleScheduleEvent } = useBookingEvent();

  // useEffect(() => {
  //   initializePixel();
  // }, []);

  useEffect(() => {
    const emailParam = searchParams.get('Email') || searchParams.get('email');
    const firstName = searchParams.get('Name') || searchParams.get('name');
    const lastName = searchParams.get('last_name');

    if (emailParam && firstName) {
      setEmail(emailParam.toLowerCase());
      setFirstName(firstName);
      setLastName(lastName);
      autoregister(emailParam.toLowerCase(), firstName, lastName);
    } else {
      setStatus('missing parameters');
      setMissingParameters(true);
    }
  }, [searchParams]);

  const sendEmail = (token) => {
    const emailContent = renderToString(htmlTemplate(token));
    const config = {
      url: 'https://zgg7z5tys4.execute-api.us-east-2.amazonaws.com/prod/email',
      method: 'post',
      data: {
        email: email,
        content: emailContent,
        subject:
          '[LOGIN INSIDE] Your Neurotoxicity Assessment is Ready to Start',
      },
      headers: {
        'x-api-key': getApiKey(),
        'Content-Type': 'application/json',
      },
    };
    axios(config)
      .then((response) => {
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const htmlTemplate = (token) => {
    return (
      <html>
        <body>
          <p>
            {firstName.split(' ')[0]} {lastName.split(' ')[0]},
          </p>
          <p>
            Your Neurotoxicity Assessment account has been created and we're
            ready for you to start your assessment.
          </p>
          <p>
            It's very important to complete this before your call with my team.
          </p>
          <p>
            This assessment is going to tell us what your upstream stressors
            are, and help us put together a plan that will put you on a path
            back to wellness as fast as possible.
          </p>
          <p>
            <a
              href={`https://apply.pompaworkshop.com/reset?token=${token}&email=${email}`}
            >
              Click here to set your password and start the assessment now.
            </a>
          </p>
          <p>Thanks,</p>
          <p>The Pompa Program Team</p>
        </body>
      </html>
    );
  };

  const autoregister = (email, firstName, lastName) => {
    const config = {
      url: getUrl() + '/autoregisteroncehub',
      method: 'post',
      data: {
        email: email,
        name: firstName,
        firstName: firstName,
        lastName: lastName,
        type: 'double',
      },
      headers: {
        'x-api-key': getApiKey(),
        'Content-Type': 'application/json',
      },
    };
    axios(config)
      .then((response) => {
        handleScheduleEvent(email.toLowerCase());
        setPassword(response.data.password);

        login(email.toLowerCase(), response.data.password, true);
      })
      .catch((error) => {
        setAuthenticating(false);
        if (error.response.status === 409) {
          setErrorMessage('User already exist, please login or reset password');
          //redirect to home after 2 seconds
          setTimeout(() => {
            navigate('/');
          }, 2000);
        } else if (
          error.response.status === 401 ||
          error.response.status === 403
        ) {
          setErrorMessage(error.response.data.message);
        } else {
          setErrorMessage(error.response.data.message);
        }
      });
  };

  const login = (email, loginPassword, sendEmailFlag) => {
    const config = {
      url: getUrl() + '/login',
      method: 'post',
      data: {
        email: email,
        password: loginPassword,
      },
      headers: {
        'x-api-key': getApiKey(),
        'Content-Type': 'application/json',
      },
    };
    axios(config)
      .then((response) => {
        setUserSessionEmail(response.data.user.email, response.data.token);
        setUserData(response.data.user);
        if (sendEmailFlag) {
          sendEmail(response.data.token);
        }
        setTimeout(() => {
          navigate('/child-profile');
        }, 3000);
      })
      .catch((error) => {
        setAuthenticating(false);
        if (error.response.status === 401 || error.response.status === 403) {
        } else {
          setErrorMessage(
            'There has been a problem with the request, please try again later'
          );
        }
      });
  };
  const submitHandler = async (event) => {
    event.preventDefault();
    if (
      firstName.trim() === '' ||
      email.trim() === '' ||
      lastName.trim() === ''
    ) {
      setErrorMessage('Both name and email are required');
      return;
    }
    setStatus('loading');

    await autoregister(email, firstName, lastName);
  };

  return (
    <Container
      component="main"
      maxWidth="xs"
      sx={{
        backgroundColor: 'background.paper',
        padding: 5,
        marginTop: 5,
      }}
    >
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <DarkLogo />
        {!missingParameters && (
          <>
            <Typography component="h1" variant="h5">
              Creating your account
            </Typography>
            <Typography component="h2" variant="h5">
              please stand by...
            </Typography>
            <Loader status={status} />
          </>
        )}
      </Box>
      {missingParameters && (
        <Box
          component="form"
          onSubmit={submitHandler}
          noValidate
          sx={{ mt: 1 }}
        >
          <Typography
            sx={{
              marginTop: 3,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
            component="h3"
            variant="h5"
          >
            Please create your account
          </Typography>
          <TextField
            margin="normal"
            required
            fullWidth
            value={firstName}
            onChange={(event) => setFirstName(event.target.value)}
            name="firstName"
            label="First Name"
            type="firstName"
            id="firstName"
            autoComplete="current-firstName"
          />
          <TextField
            margin="normal"
            required
            fullWidth
            value={lastName}
            onChange={(event) => setLastName(event.target.value)}
            name="lastName"
            label="Last Name"
            type="lastName"
            id="lastName"
            autoComplete="current-lastName"
          />
          <TextField
            margin="normal"
            required
            fullWidth
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            name="email"
            label="Email"
            type="email"
            id="email"
            autoComplete="off"
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            disabled={authenticating}
            sx={{ mt: 3, mb: 2 }}
          >
            Set Password
          </Button>
        </Box>
      )}

      <div style={{ marginTop: '10px' }}>
        {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
      </div>
    </Container>
  );
}
